import React from 'react';

import { L10n } from '../../../ts/L10n/L10n';
import { IExplorableItemTypeInfo } from '../../../ts/models/resourceInfoParts';
import { CardViewStyles } from './CardViewStyles';

export interface GenericCardProps {
  content: IExplorableItemTypeInfo;
}

export function GenericCard(props: GenericCardProps): React.ReactElement<GenericCardProps> {
  return (
    <div className={CardViewStyles.Card}>
      <div className={CardViewStyles.Thumbnail}>
        <span>{L10n.elideIfLong(props.content.id)}</span>
        <span>{props.content.contentType}</span>
      </div>
      <div className={CardViewStyles.ActionRow}>
        <span className={CardViewStyles.ActionRowName} title={L10n.elideIfLong(props.content.name)}>
          {L10n.elideIfLong(props.content.name)}
        </span>
      </div>
    </div>
  );
}
